import { render, staticRenderFns } from "./BankReceipt.vue?vue&type=template&id=28566b67&"
import script from "./BankReceipt.vue?vue&type=script&lang=js&"
export * from "./BankReceipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports